export default __webpack_public_path__ + "static/media/orders.d5e91797.svg";